import { withProps } from 'recompose'
import { getFreeAlignmentCheckBlockState, getItemWithFilteredServices } from 'components/ShoppingQuote/BOTProductAndServicesQuote/helpers'
import QuotedItem from './QuotedItem'

export default withProps(
  ({ quotedItemAndServices, freeAlignmentCheckSku }) => ({
    freeAlignmentCheckDisabled:
      !freeAlignmentCheckSku.commerceItemId ||
      getFreeAlignmentCheckBlockState({ quotedItemAndServices, freeAlignmentCheckSku }),
    quotedItemAndServices: getItemWithFilteredServices({ quotedItemAndServices, freeAlignmentCheckSku })
  })
)(QuotedItem)
